<template lang='pug'>
  .fpui-input-style(:class='className')
    .label(@click="open = !open" v-if='withLabel')
      span
        slot
      i.fpui(:class="{'fpui-chevron-up':!open,'fpui-chevron-down':open}")
    .values(v-if="open")
      .values-container
        .value-container(v-for='(style, index) in values', :key='index')
          .row(v-if='style')
            multiselect.col-xs-5(
              :value='style.key',
              @input="update(index, 'key', $event)"
              :options='options'
              :show-labels="false"
              :placeholder="$t('editor.core-ui.style.key.placeholder')"
            )
            fpui-input-text.col-xs-6(
              :value='style.value',
              @input="update(index, 'value', $event)"
              :placeholder="$t('editor.core-ui.style.value.placeholder')"
            )
            fpui-button.pull-left(@click='remove(index)', :icon="icon", :color="color" unbordered, reverse)

      fpui-button.add(@click="add",icon="fpui fpui-plus", :reverse='true', :unbordered='true')
        | {{ $t('add') }}
</template>

<script>
import isEqual from 'lodash/isEqual'
import camelCase from 'lodash/camelCase'
import { CSSPropertiesList } from './FpuiCSSPropertiesList';

export default {
  props: {
    value: { type: [String, Object], required: true, default: '' },
    disabled: { type: Boolean, default: false },
    defaultOpen: { type: Boolean, default: true },
    withLabel: { type: Boolean, default: true },
    icon: { type: String, default: "fpui fpui-remove" },
    color: { type: String, required: false }
  },
  data () {
    return {
      open: this.defaultOpen,
      values: [],
      options: CSSPropertiesList
    }
  },
  mounted () {
    this.values = Object.keys(this.value).map(key => ({
      key: key,
      value: this.value[key]
    }))
    if (this.values.length === 0) this.add()
  },
  methods: {
    add () {
      let check = this.values.find(style => style.key === '')
      if (!check) {
        this.values.push({key: '', value: ''})
        this.$emit('input', this.cleaned)
      }
    },
    update (index, type, value) {
      if (type === 'key') value = camelCase(value)
      this.$set(this.values[index], type, value)
      let cleaned = this.cleaned
      if (!isEqual(cleaned, this.value)) this.$emit('input', cleaned)
    },
    remove (index) {
      this.values.splice(index, 1)
      this.$emit('input', this.cleaned)
    }
  },
  computed: {
    cleaned () {
      let model = {}
      this.values.forEach(style => {
        if (style.key.length > 0 && style.value.length > 0) {
          model[style.key] = style.value
        }
      })
      return model
    },
    className () {
      let className = []
      if (this.disabled) className.push('disabled')
      return className.join(' ')
    },
    autocomplete () {
      return []
    }
  }
}
</script>

<style lang='less'>
@import "~@/shared/styles/_variables.less";

  .fpui-input-style {
    .label {
      padding:0 15px 0 0;
      width:100%;
      display: inline-block;
      position: relative;
      cursor: pointer;
      &:before {
        width:90%;
        left:5%;
        height:1px;
        top:16px;
        background-color:#eee;
        position: absolute;
        content:"";
      }
      span {
        background:white;
        position: relative;
        width:18%;
        display: inline-block;
        padding:0 15px;
      }
      i {
        background:white;
        color:#10B6E9;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .values {
      width:100%;
      padding-left: 45px;
      position: relative;
      .values-container {
        padding-top: 40px;
        .value-container {
          .row {
            padding: 5px 0px;
            .col-xs-5, .col-xs-6, .col-xs-1 {
              padding-left: 5px;
              padding-right: 5px;
            }
          }
        }
      }
    }
    .add {
      float: right;
      margin-right: 10px;
    }
  }
</style>
